import React from 'react';
import { Button, Modal } from 'react-bootstrap-5';
import { selectEmbeddedMode } from '../../store/selectors/ui';
import { useSelector } from 'react-redux';
import { BUILDOUT_CRM_MODE, RETHINK_MODE } from '../../embedded_mode';

type PropertySyncBatchCompleteModalProps = {
  saveContact: boolean,
  onHide: () => void
}

export default function PropertySyncBatchCompleteModal(
  { saveContact, onHide }: PropertySyncBatchCompleteModalProps
) {
  const embeddedMode = useSelector(selectEmbeddedMode);

  const output = () => {
    switch (embeddedMode) {
    case BUILDOUT_CRM_MODE:
      return 'CRM';
    case RETHINK_MODE:
      return 'list';
    default:
      return 'list';
    }
  };

  const title = () => {
    switch (embeddedMode) {
    case BUILDOUT_CRM_MODE:
      return 'Property Sync Complete';
    case RETHINK_MODE:
      return 'List Creation Complete';
    default:
      return 'List Creation Complete';
    }
  };

  return (
    <>
      <Modal.Header className="flex-row" closeButton>
        <h5 className="mb-0">{title()}</h5>
      </Modal.Header>
      <Modal.Body>
        <div>
          Property {saveContact ? 'and owner contact data have' : 'data has'} been added to your {output()}.
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="link" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </>
  );
}
